import React, { useState, useEffect } from 'react'
import axios from 'axios';
import CategoriesForm from './form/CategoriesForm';
import useEndpoints from '../../API/apiConfig';
import LoadingSpinner from './UI/LoaderSpinner';

export default function CategoriesManager() {
    const endpoints = useEndpoints()
    const [categories, setCategories] = useState([]);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [isLoading, setIsloading] = useState(true)
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.data?.token;

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    const fetchCategories = async () => {
        const response = await axios.get(`${endpoints.CATEGORIES}`, { headers });
        setCategories(response.data);
        setIsloading(false)
    };

    const createCategory = async (data) => {
        try {
            await axios.post(`${endpoints.CATEGORIES_ADD}`, data, { headers });
            fetchCategories();
            setCurrentCategory(null)
        } catch (error) {
            console.error("Error creating categoryer:", error);
        }
    };

    const updateCategory = async (data) => {
        await axios.post(`${endpoints.CATEGORIES_UPDATE}`, data, { headers });
        fetchCategories();
        setCurrentCategory(null)
    };
    const deleteCategory = async (id) => {
        console.log(`${endpoints.CATEGORIES_DELETE}?id=${id}`)
        await axios.delete(`${endpoints.CATEGORIES_DELETE}?id=${id}`, { headers });
        fetchCategories();
    };
    const resetCurrentItem = () => {
        setCurrentCategory(null)
    }

    useEffect(() => {
        fetchCategories();
    }, []);
    console.log(currentCategory)
    return (
        <section className='manager'>
            <h1 className='manager__title'>Управление категориями</h1>
            <CategoriesForm category={currentCategory} onSubmit={currentCategory ? updateCategory : createCategory} resetCurrentCategory={resetCurrentItem} />
            <h2 className='manager__title_h2'>Список категорий</h2>
            {isLoading ?
                <LoadingSpinner />
                :
                <ul className='manager__ul'>
                    {categories.map(category => (
                        <li className='manager__li' key={category.idCategory}>
                            {category.categoryName}
                            <div>
                                <button className='manager__button' onClick={() => setCurrentCategory(category)}>Редактировать</button>
                                <button className='manager__button' onClick={() => deleteCategory(category.idCategory)}>Удалить</button>
                            </div>
                        </li>
                    ))}
                </ul>
            }
        </section>
    );
}
